class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  /* ========= Keep bubble visible at 0 ========= */
  ensureHeaderBubbleVisible(countParam) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    let bubble = cartLink.querySelector('.cart-count-bubble');
    const safeCount = (typeof countParam === 'number' && !isNaN(countParam))
      ? countParam
      : (() => {
          const n = cartLink.querySelector('.cart-count-bubble [aria-hidden="true"]');
          return n ? (parseInt(n.textContent, 10) || 0) : 0;
        })();

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartLink.appendChild(bubble);
    }

    bubble.innerHTML = `
      <span aria-hidden="true">${safeCount}</span>
      <span class="visually-hidden">${safeCount} ${safeCount === 1 ? 'item in cart' : 'items in cart'}</span>
    `;

    if (safeCount === 0) bubble.classList.add('empty'); else bubble.classList.remove('empty');

    // NU o ascunde niciodată, chiar dacă serverul trimite [hidden]
    bubble.removeAttribute('hidden');
    bubble.classList.remove('hidden');
    bubble.style.display = 'inline-flex';
    bubble.style.visibility = 'visible';

    cartLink.removeAttribute('hidden');
    cartLink.classList.remove('hidden');
    cartLink.style.removeProperty('display');
  }

  async syncHeaderBubbleWithCartAPI() {
    try {
      const res = await fetch(`/cart.js?cb=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
      const cart = await res.json();
      const count = Number(cart.item_count) || 0;
      this.ensureHeaderBubbleVisible(count);
    } catch {
      this.ensureHeaderBubbleVisible(0);
    }
  }
  /* ========= END ========= */

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // după închidere, sincronizează bulă (important când a ajuns 0)
    setTimeout(() => this.syncHeaderBubbleWithCartAPI(), 50);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.warn('⚠️ parsedState.sections este undefined.');
      return;
    }

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    // 🔧 RENDER NUMAI CART DRAWER — nu mai atingem cart-icon-bubble din server
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
    });

    // după rerender, aliniază bula la numărul real
    this.syncHeaderBubbleWithCartAPI();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      // ❌ scos { id: 'cart-icon-bubble' }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      // ❌ scos blocul care rerenderuia `cart-icon-bubble`
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section',
      // },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ========= Sync bulă și pe evenimente globale ========= */
document.addEventListener('cart:updated', () => {
  const cd = document.querySelector('cart-drawer');
  if (cd && typeof cd.syncHeaderBubbleWithCartAPI === 'function') cd.syncHeaderBubbleWithCartAPI();
});
document.addEventListener('cart:refresh', () => {
  const cd = document.querySelector('cart-drawer');
  if (cd && typeof cd.syncHeaderBubbleWithCartAPI === 'function') cd.syncHeaderBubbleWithCartAPI();
});
